export const OrderedType = {
  Weight: "WEIGHT",
  Dimension: "DIMENSION",
  Length: "LENGTH",
  Surface: "SURFACE"
};

export const Unit = {
  Rolls: "RL"
};



// WEBPACK FOOTER //
// ./src/components/Common/UnitsSelector/Units.js